module.exports = __webpack_public_path__ + "img/demo2.49850505.jpg";